module.exports = __webpack_public_path__ + "img/king_JZ.78860c83.png";